var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-icon",class:_vm.iconClass,on:{"click":function($event){return _vm.$emit("click")}}},[_vm._v(_vm._s(_vm.iconName))])}
var staticRenderFns = []

export { render, staticRenderFns }